import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core'
import { filter, Observable, Subscription, switchMap, take, takeUntil, timer } from 'rxjs'

@Component({
  selector: 'gb-payment-pending',
  templateUrl: './gb-payment-pending.component.html',
  styleUrls: ['./gb-payment-pending.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPaymentPendingComponent {
  @Input() isPaymentPending$!: Observable<boolean>
  @Output() onPaymentPendingDelayed = new EventEmitter<void>()

  paymentPendingSub?: Subscription
  paymentPendingDelayed = false
  paymentPendingTimerExpired = false

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.watchPaymentPending()
  }

  ngOnDestroy(): void {
    this.paymentPendingSub?.unsubscribe()
  }

  watchPaymentPending(): void {
    this.paymentPendingSub = this.createPaymentPendingTimer()
      .pipe(
        switchMap(() => {
          this.onPaymentPendingDelayed.emit()
          this.paymentPendingDelayed = true
          this.cdr.detectChanges()
          return this.createPaymentPendingTimer()
        }),
        takeUntil(this.isPaymentPending$.pipe(filter((isPaymentPending) => !isPaymentPending))),
        take(2),
      )
      .subscribe(() => {
        this.paymentPendingTimerExpired = true
        this.cdr.detectChanges()
      })
  }

  /**
   * Create a timer that emits after 30 seconds if payment still pending
   */
  createPaymentPendingTimer(): Observable<boolean> {
    return timer(30000).pipe(
      switchMap(() => this.isPaymentPending$),
      filter((isPaymentPending) => isPaymentPending),
    )
  }
}
